import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import View from "./ClubSearchView";
import { requestSearchClubs } from "../../../modules/club/actions";

function mapStateToProps(state) {
    return {
        clubs: state.searchClubs
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            requestSearchClubs
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./src/components/Search/Navbar/ClubSearch.js